import React from 'react';
import { withStyles,
  Fade,
  Avatar,
  Typography,
  Button,
  Slide,
  IconButton,
  FormControl,
  Paper,
  TextField } from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import TrashIcon from '@material-ui/icons/Delete';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Edit from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import MUIDataTable from 'mui-datatables';
import LinearProgressBlockScreen from '../../share/LinearProgressBlockScreen';
import LongMenu from '../../share/LongMenu';
import AlertDialogSlide from '../../share/AlertDialogSlide';
import ToolbarNovo from '../../share/ToolbarNovo';
import VariantSnackbar from '../../share/VariantSnackbar';
import ClearIcon from '@material-ui/icons/Clear';
import ReplayIcon from '@material-ui/icons/Replay';
import DialogErrosValidacao from '../../share/DialogErrosValidacao';
import VigenciaPorteService from '../../../services/VigenciaPorteService';
import { format } from 'date-fns';
import FormDialogVigenciaPorte from './FormDialogVigenciaPorte';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'block',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 220,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    width: 450,
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
  },
  searchIcon: {
    marginLeft: theme.spacing.unit,
  },
  input: {
    margin: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    marginLeft: '20px'
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
});
@inject('aplicacaoStore')
@observer
class VigenciaPorteCadastro extends React.Component {
  vigenciaPorteService = new VigenciaPorteService();
  state = {
    codPorteSelected: '',
    vigencias: [],
    portes: [],
    fetching: false,
    buscarDisabled: true,
    anchorEl: null,
    vigenciaSelecionada: {},
    openDialogExclusao: false,
    openDialog: false,
    modoInclusao: true,
    modoCancelamento: true,
    isEditavel: true,
    tituloFormDialog: '',
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    openDialogValidacao: false,
    dialogTitle: '',
    dialogContent: '',
    dialogTitleExclusao: 'Exclusão de Vigência',
    dialogMessage: 'Deseja excluir esta vigência?',
    sucesso: true,
    openDialogCancelamento: false,
    openDialogDesfazerCancelamento: false,
    dialogTitleCancelamento: '',
    dialogMessageCancelamento: '',
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarVigencias();
    await this.consultarPortes();
    this.setState({fetching: false});
  }
  consultarVigencias = async () => {
    let vigencias = await this.vigenciaPorteService.consultarVigencias(this.state.codPorteSelected === '' ? -1 : this.state.codPorteSelected);
    this.setState({vigencias: vigencias});
  }
  consultarPortes = async () => {
    let portes = await this.vigenciaPorteService.consultarPortes();
    this.setState({portes: portes});
  }
  handleChangeTextField = event => {
    var valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 3);
    this.setState({ [event.target.name]: valorNovo, buscarDisabled: event.target.value === '' });
  };
  handleClickBuscar = async (event) => {
    event.preventDefault();
    await this.consultarVigencias();
  }
  handleClickMenu = (event, tableMeta) => {
    const nf = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });        
    const vigenciaSelecionada = {
      codVigencia: this.state.vigencias[tableMeta.rowIndex][0],
      codPorteAnestesico: this.state.vigencias[tableMeta.rowIndex][1],
      valPorte: nf.format(this.state.vigencias[tableMeta.rowIndex][2]),
      dtaInicio: this.state.vigencias[tableMeta.rowIndex][3],
      dtaFim: this.state.vigencias[tableMeta.rowIndex][4],
      dtaCancelamento: this.state.vigencias[tableMeta.rowIndex][5],
      txtMotivoCancelamento: this.state.vigencias[tableMeta.rowIndex][6],
    };
    this.setState({ anchorEl: event.currentTarget, vigenciaSelecionada: vigenciaSelecionada });
  }
  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }
  handleChangeMenu = (index) => {
    this.setState({anchorEl: null});
    if (index === 0) {
      this.setState({openDialog: true, tituloFormDialog: 'Alteração de Vigência', modoInclusao: false, isEditavel: true});
    }
    if (index === 1) {
      this.setState({ openDialogExclusao: true });
    }
  }
  handleDialogClose = async () => {
    this.setState({openDialog: false});
    await this.consultarVigencias();
  };
  onOperacaoFinalizadaDialog = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        openDialog: false,
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        sucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({
          openDialog: false,
          snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          fetching: false,
          sucesso: true});
      } else {
        this.setState({
          openDialog: false,
          openDialogValidacao: true,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false});
      }
    }
    await this.consultarVigencias();
  }
  onOperacaoFinalizada = async (msg) => {
    this.setState({fetching: false, snackOpen: true, snackMessage: msg, sucesso: true, codPorteSelected: 0});
    await this.consultarVigencias();
  }

  handleDialogConfirmExclusao = async () => {
    this.setState({ openDialogExclusao: false, fetching: true });
    await this.excluirVigencia();
  }
  handleCloseDialogExclusao = () => {
    this.setState({ openDialogExclusao: false });
  };
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  handleCloseDialogValidacao = () => {
    this.setState({ openDialogValidacao: false });
  };
  handleClickIncluir = () => {
    this.setState({openDialog: true, tituloFormDialog: 'Inclusão de Vigência', vigenciaSelecionada: {}, modoInclusao: true, isEditavel: true});
  }
  handleClickCancelar = (event, tableMeta) => {
    const vigenciaSelecionada = {
      codVigencia: this.state.vigencias[tableMeta.rowIndex][0],
    };
    this.setState({openDialogCancelamento: true, dialogTitleCancelamento: 'Cancelamento de Vigência - ' + vigenciaSelecionada.codVigencia, dialogMessageCancelamento: 'Deseja cancelar esta Vigênica? Favor informar o motivo do cancelamento:', modoCancelamento: true, vigenciaSelecionada: vigenciaSelecionada});
  }
  handleClickDesfazerCancelamento = (event, tableMeta) => {
    const vigenciaSelecionada = {
      codVigencia: this.state.vigencias[tableMeta.rowIndex][0],
    };
    this.setState({openDialogDesfazerCancelamento: true, dialogTitleCancelamento: 'Desfazer Cancelamento - ' + vigenciaSelecionada.codVigencia, dialogMessageCancelamento: 'Deseja desfazer o cancelamento desta Vigência?', modoCancelamento: false, vigenciaSelecionada: vigenciaSelecionada});
  }
  handleCloseDialogCancelamento = () => {
    this.setState({ openDialogCancelamento: false, openDialogDesfazerCancelamento: false });
  };
  handleDialogConfirmCancelamento = async (motivoCancelamento) => {
    this.setState({ openDialogCancelamento: false, openDialogDesfazerCancelamento: false, fetching: true });
    if (this.state.modoCancelamento) {
      await this.cancelarVigencia(motivoCancelamento);
    } else {
      await this.desfazerCancelamentoVigencia();
    }
  }
  cancelarVigencia = async (motivoCancelamento) => {
    this.setState({fetching: true});
    await this.vigenciaPorteService.cancelarVigencia(this.state.vigenciaSelecionada.codVigencia, motivoCancelamento);
    await this.onOperacaoFinalizada('Vigência cancelada com sucesso!');
  }
  desfazerCancelamentoVigencia = async () => {
    this.setState({fetching: true});
    await this.vigenciaPorteService.desfazerCancelamentoVigencia(this.state.vigenciaSelecionada.codVigencia);
    await this.onOperacaoFinalizada('Cancelamento desfeito com sucesso!');
  }
  incluirVigencia = async (vigencia) => {
    this.setState({fetching: true, vigenciaSelecionada: {}});
    let result = await this.vigenciaPorteService.validarVigencia(vigencia, 'S');
    if (result.data === '') {
      result = await this.vigenciaPorteService.incluirVigencia(vigencia);
      await this.onOperacaoFinalizadaDialog(result);
    } else {
      this.setState({openDialog: false, fetching: false, snackOpen: true, snackMessage: 'Operação não realizada. ' + result.data, sucesso: false});
    }
  }
  alterarVigencia = async (vigencia) => {
    this.setState({fetching: true, vigenciaSelecionada: {}});
    let result = await this.vigenciaPorteService.validarVigencia(vigencia, 'N');
    if (result.data === '') {
      result = await this.vigenciaPorteService.alterarVigencia(vigencia);
      await this.onOperacaoFinalizadaDialog(result);
    } else {
      this.setState({openDialog: false, fetching: false, snackOpen: true, snackMessage: 'Operação não realizada. ' + result.data, sucesso: false});
    }
  }
  excluirVigencia = async () => {
    this.setState({fetching: true});
    const result = await this.vigenciaPorteService.excluirVigencia(this.state.vigenciaSelecionada.codVigencia);
    await this.onOperacaoFinalizadaDialog(result);
  }
  render () {
    const options = {
      customToolbar: () => (
        <ToolbarNovo
          handleClickIncluir={this.handleClickIncluir}
        />
      ),
      setRowProps: (row) => {
        return {
          title: row[6] !== '' && 'Esta vigência foi cancelada em ' + format(new Date(row[5]), 'DD/MM/YYYY') + ' por ' + row[8] + ': ' + row[6],
          className: row[6] !== '' ? this.props.classes.tableRowCancelado : '',
        };
      },
      print: false,
      download: false,
      selectableRows: false,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>vigência(s) selecionada(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Sequencial',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Código Porte',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return <Typography style={{fontSize: 12}}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Valor Porte',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable} style={{fontSize: 12}}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Data Início',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Data Fim',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Data Cancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Motivo Cancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Cod Usuario Cancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Nome Usuario Cancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Cancelamento',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              value === 'CANCELAR'
                ? <IconButton
                  id={'menuButton'}
                  className={classes.iconButton}
                  aria-label='More'
                  aria-owns={open ? 'long-menu' : null}
                  aria-haspopup='true'
                  title={'Cancelar o Acerto'}
                  onClick={event => this.handleClickCancelar(event, tableMeta)}
                >
                  <ClearIcon fontSize='default' />
                </IconButton>
                : <IconButton
                    id={'menuButton'}
                    className={classes.iconButton}
                    aria-label='More'
                    aria-owns={open ? 'long-menu' : null}
                    aria-haspopup='true'
                    title={'Desfazer o Cancelamento'}
                    onClick={event => this.handleClickDesfazerCancelamento(event, tableMeta)}
                  >
                    <ReplayIcon fontSize='default' />
                  </IconButton>
            );
          },
        }
      },
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            let options = [
              {
                index: 0,
                icon: <Edit />,
                primaryText: 'Editar Vigência...',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <TrashIcon />,
                primaryText: 'Excluir Vigência...',
                visible: true,
                disabled: false
              },
            ];
            return (
              <LongMenu
                menuOptions={options}
                anchorEl={this.state.anchorEl}
                handleClick={this.handleClickMenu}
                handleChange={this.handleChangeMenu}
                handleClose={this.handleCloseMenu}
                selectedItem={tableMeta} />
            );
          },
        }
      },
    ];

    const { classes } = this.props;
    const { fetching, vigencias } = this.state;
    return (
      <React.Fragment>
        <Link to='/tabelasApoio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Vigências de Porte Anestésico</Typography>
              {vigencias && <Avatar className={classes.avatar}>{vigencias.length}</Avatar>}
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <form className={classes.container} noValidate>
            <FormControl className={classes.formControl}>
              <TextField
                value={(this.state.codPorteSelected === null || this.state.codPorteSelected === undefined) ? '' : this.state.codPorteSelected}
                className={classes.textField}
                margin='dense'
                id='codPorteSelected'
                name='codPorteSelected'
                placeholder='Pesquise pelo Porte...'
                fullWidth
                onChange={this.handleChangeTextField}
              />
            </FormControl>
            <Button
              variant='extendedFab'
              title='Consultar'
              type='submit'
              onTouchStart={this.handleClickBuscar}
              onClick={this.handleClickBuscar}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Buscar
            </Button>
          </form>
        </Paper>
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={vigencias}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
        {this.state.openDialog &&
          <FormDialogVigenciaPorte
            titulo={this.state.tituloFormDialog}
            vigencia={this.state.vigenciaSelecionada}
            portes={this.state.portes}
            open={this.state.openDialog}
            modoInclusao={this.state.modoInclusao}
            handleClose={this.handleDialogClose}
            handleSave={this.state.modoInclusao ? this.incluirVigencia : this.alterarVigencia}
            isEditavel={this.state.isEditavel} />}
        <AlertDialogSlide
          open={this.state.openDialogExclusao}
          handleClose={this.handleCloseDialogExclusao}
          handleClick={this.handleDialogConfirmExclusao}
          title={this.state.dialogTitleExclusao}
          message={this.state.dialogMessage} />
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        <AlertDialogSlide
          open={this.state.openDialogCancelamento}
          handleClose={this.handleCloseDialogCancelamento}
          handleClick={this.handleDialogConfirmCancelamento}
          title={this.state.dialogTitleCancelamento}
          editavel
          message={this.state.dialogMessageCancelamento} />
        <AlertDialogSlide
          open={this.state.openDialogDesfazerCancelamento}
          handleClose={this.handleCloseDialogCancelamento}
          handleClick={this.handleDialogConfirmCancelamento}
          title={this.state.dialogTitleCancelamento}
          message={this.state.dialogMessageCancelamento} />
        {this.state.openDialogValidacao &&
          <DialogErrosValidacao
            open={this.state.openDialogValidacao}
            handleClose={this.handleCloseDialogValidacao}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
          />}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(VigenciaPorteCadastro);
